import type { ResourceMap } from '../resources/types';
import type { PurchasesList } from '../../libs/offerSystem/OfferSystemHistory';
import type { AllProps } from '../../libs/propsMixin/props';
import type { RawLayoutData } from '../../libs/layouts/types/RawLayout';
import type { OfferDefinition, OfferVariant } from '../../libs/offerSystem/offerSystemTypes';
import type { Condition } from './conditionsTypes';
import type { ActiveOfferData } from '../../libs/offerSystem/OfferSystemController';

export enum OfferLocation {
  Shop = 'Shop',
  LevelFailBanner = 'LevelFailBanner',
  MenuButton = 'MenuButton',
  MenuPopup = 'MenuPopup',
  LevelFailPopup = 'LevelFailPopup',
  AdFallback = 'AdFallback',
}

export enum OfferTrigger {
  OpenMainMenu = 'OpenMainMenu',
  LevelFailed = 'LevelFailed',
  ExitShopNoPurchase = 'ExitShop',
  NotEnoughCoins = 'NotEnoughCoins',
  OpenShop = 'OpenShop',
}

export enum OfferTag {
  StarterBundle = 'StarterBundle',
  BasicGold = 'BasicGold',
  PiggyBank = 'PiggyBank',
  BasicBundle = 'BasicBundle',
  UpsellBundle = 'UpsellBundle',
  SafetyNet = 'SafetyNet',
  EventPass = 'EventPass',
}

export interface OffersGameData {
  popupLayout?: {
    path?: string; // relative path under /layouts (e.g., "specialOffers/SpecialOffersLayout")
    raw?: RawLayoutData; // raw layout JSON chunk
    skin?: string;
  };
  menuIconAssets?: {
    icon: AllProps;
  };

  // TODO it is not clear enough that it is shop view, unify that
  offerPopupView?: {
    background: string;
  };

  shopOfferView?: {
    layoutPath?: string;
  };

  offerSimpleView?: {
    icon: AllProps;
  };
}

export type GameOfferDefinition = OfferDefinition<Condition, OffersGameData>;

export type GameOfferVariant = OfferVariant<Condition, OffersGameData>;

export type GameActiveOfferData = ActiveOfferData<Condition, OffersGameData>;

export interface StateProxy {
  getLevelNumber(): number;
  getInventory(): ResourceMap;
  getCurrentTime(): number;
  getUserCreateDate(): number;
  getBand(history: PurchasesList): number;
  isTier1(): boolean;
  isInSeasonPassWithoutPremium(): boolean;
}
